import CLIENT from '../utils/restClient';
import { ReturnDisplayType } from '../utils/enums';

const CorrectionGroupingFilters = [
    ReturnDisplayType.SHOW_CORRECTIONS_GROUP_BY_PERIOD.value,
    ReturnDisplayType.SHOW_CORRECTIONS_GROUP_BY_PERIOD_INCLUDING_ORIGINAL_DOCUMENTS.value
];

export const MODULE_NAME = 'FILING_CORRECTIONS_CONTROLLER';

function namespaced(name) {
    return MODULE_NAME + '.' + name;
}

const LOAD_CORRECTION_PERIODS = namespaced('LOAD_CORRECTION_PERIODS');
const LOAD_CORRECTION_PERIODS_OK = namespaced('LOAD_CORRECTION_PERIODS_OK');
const LOAD_CORRECTION_PERIODS_FAIL = namespaced('LOAD_CORRECTION_PERIODS_FAIL');
const UNLOAD_CORRECTION_PERIODS = namespaced('UNLOAD_CORRECTION_PERIODS');

export const ACTION_TYPES = {
    LOAD_CORRECTION_PERIODS,
    LOAD_CORRECTION_PERIODS_OK,
    LOAD_CORRECTION_PERIODS_FAIL,
    UNLOAD_CORRECTION_PERIODS
};

export const updateSubStateFromAction = (state = { loading: false, error: null }, action) => {
    switch (action.type) {
        case LOAD_CORRECTION_PERIODS:
            return Object.assign({}, state, { loading: true, error: null });
        case LOAD_CORRECTION_PERIODS_OK:
            const correctionPeriods = action.response?.correctionPeriods;
            return Object.assign({}, state, {
                correctionPeriods: correctionPeriods,
                loading: false,
                error: null
            });
        case LOAD_CORRECTION_PERIODS_FAIL:
            return Object.assign({}, state, { correctionPeriods: undefined, loading: false, error: action.error });
        case UNLOAD_CORRECTION_PERIODS:
            return Object.assign({}, state, {
                correctionPeriods: undefined,
                loading: false,
                error: null
            });
        default:
            return state;
    }
};

export const API = {

    isGroupedDisplayType(returnDisplayType) {
        return CorrectionGroupingFilters.includes(+returnDisplayType);
    },

    doLoadCorrectionPeriods: (filterParams) => {
        return async (dispatch) => {
            dispatch({ type: LOAD_CORRECTION_PERIODS });
            try {
                const response = await CLIENT.getCorrectionPeriods(filterParams);
                dispatch({ type: LOAD_CORRECTION_PERIODS_OK, response: response });
            } catch (error) {
                dispatch({ type: LOAD_CORRECTION_PERIODS_FAIL, error });
            }
        }
    },

    doLoadECCorrectionPeriods: (filterParams) => {
        return async (dispatch) => {
            dispatch({ type: LOAD_CORRECTION_PERIODS });
            try {
                const response = await CLIENT.getECCorrectionPeriods(filterParams);
                dispatch({ type: LOAD_CORRECTION_PERIODS_OK, response: response });
            } catch (error) {
                dispatch({ type: LOAD_CORRECTION_PERIODS_FAIL, error });
            }
        }
    },

    doUnloadCorrectionPeriods: () => {
        return (dispatch) => {
            dispatch({ type: UNLOAD_CORRECTION_PERIODS });
        }
    }

};

export default API;
